import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../config";

const CREATE_SESSION_URL = `${API_BASE_URL}/api/admin/create/session`;

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError("");

    try {
      const { data } = await axios.post(CREATE_SESSION_URL, {
        username: username.trim(),
        password,
      });

      const token = data?.token
      if (!token) throw new Error("No token returned from server.");

      localStorage.setItem("admin_auth_token", token);

      const redirectTo = location.state?.from?.pathname || "/question-audit";
      navigate(redirectTo, { replace: true });
    } catch (e2) {
      setError(e2?.response?.data?.error || e2?.message || "Admin sign-in failed.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="mx-auto max-w-md">
        <div className="rounded-2xl border bg-white p-6 shadow-sm">
          <h1 className="text-2xl font-semibold">Admin Sign In</h1>
          <p className="mt-1 text-sm text-gray-600">Restricted access.</p>

          {error && (
            <div className="mt-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              {error}
            </div>
          )}

          <form className="mt-6 space-y-4" onSubmit={onSubmit}>
            <div className="">
              <label className="text-sm font-medium">Username</label>
              <input
                className="mt-2 w-full rounded-xl px-3 py-4 text-sm shadow-lg shadow-black/50 focus:shadow-cyan-500"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
              />
            </div>

            <div>
              <label className="text-sm font-medium">Password</label>
              <input
                className="mt-2 w-full rounded-xl px-3 py-4 text-sm shadow-lg shadow-black/50 focus:shadow-cyan-500 focus:outline-none"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            <button
              className="w-full rounded-xl bg-black px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
              type="submit"
              disabled={submitting || !username.trim() || !password}
            >
              {submitting ? "Signing in…" : "Sign In"}
            </button>
          </form>

          <p className="mt-4 text-xs text-gray-500">
            Reset is console-only (by design).
          </p>
        </div>
      </div>
    </div>
  );
}
